import Component from '@glimmer/component';

export type AskFilteredOrSelectedAnswer = 'filtered' | 'selected';

interface ComponentArgs {
  selectedContactIds: string[];
  filteredContactIds: string[];
  onAnswer: (answer: AskFilteredOrSelectedAnswer) => void;
  onClose: () => void;
}

export default class ContactBulkActionsAskFilteredOrSelectedContactComponent extends Component<ComponentArgs> {
  get someSelectedContactIdsAreNotShowing() {
    let { selectedContactIds, filteredContactIds } = this.args;
    return selectedContactIds.some((x) => !filteredContactIds.includes(x));
  }
}
